import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_defineProperty.js
var defineProperty = function() {
	try {
		var func = _getNative_default(Object, "defineProperty");
		func({}, "", {});
		return func;
	} catch (e) {}
}();
var _defineProperty_default = defineProperty;

//#endregion
export { _defineProperty_default as default };
//# sourceMappingURL=_defineProperty.js.map